<template>
    <div class="AdminHeader">
        <div class="header-body">
            <div class="header-left">
                <span>MPC合约参数管理</span>
            </div>
            <div class="header-right">
                <div class="walletShow" v-if="walletAddress">{{showAddress(walletAddress)}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '@/assets/js/bus';
import { getUserName,getUserSign } from '@/assets/js/user';
export default {
    data() {
        return {
            walletAddress:"",
            curMenu:"",
        };
    },
    created(){
        this.curMenu = this.$route.path;
        bus.$on('refreshWalletData',async() =>  {
            this.walletAddress = getUserName();
        });
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
        }
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
    },
    methods:{
        choosed(command){
            if(command == this.curMenu){
                return;
            }
            this.curMenu = command;
            this.$router.push({path:command});
        }
    }
}
</script>
<style lang='less' >
.AdminHeader{
.menu-item{
    display:flex;
    align-items:center;
    margin-bottom:5px;
    img{
        width:16px;
        height:16px;
        margin-right:10px;
    }
    i.el-icon-info{
        margin-right:10px;
    }
}
}
</style>
<style lang='less' scoped>
.AdminHeader{
    .header-body{
        display:flex;
        align-items:center;
        justify-content: space-between;
        height:42px;
        background: linear-gradient(90deg, #0089E0, #00429A);
        .header-left{
            font-size:18px;
            font-weight: 600;
            cursor:pointer;
            color: #fff;
            padding-left: 10px;
        }
        .header-right {
            display:flex;
            justify-content:flex-end;
            align-items:center;
            margin-right: 10px;
            .walletShow{
                font-size:16px;
                font-weight: 600;
                cursor:pointer;
                color: #fff;
            }
            .dropdown-icon{
                cursor:pointer;
                -webkit-tap-highlight-color:rgba(0,0,0,0); 
                margin-left: 10px;
                img{
                    height:16px;
                    height:16px;
                }
            }
        }
    }
}
</style>